import type { DocumentListEntryPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import type DocumentListItemView from '@UI/Store/Documents/Views/DocumentListItemView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A `list` node, `type: 'list'` discriminant. A pure data holder: `items` arrives already built,
 * same motif as `DocumentGroupView.entries`.
 */
class DocumentListEntryView {
	readonly type: 'list';
	readonly uuid: string;
	readonly path: string;
	readonly title: string;
	readonly description: string | null;
	/** Opaque key, sent back as is to the item routes. */
	readonly key: string;
	/** `null` = unbounded. */
	readonly minItems: number | null;
	readonly maxItems: number | null;
	readonly items: readonly DocumentListItemView[];

	constructor(
		payload: Pick<
			DocumentListEntryPayload,
			'uuid' | 'path' | 'title' | 'description' | 'key' | 'minItems' | 'maxItems'
		>,
		items: readonly DocumentListItemView[],
	) {
		this.type = 'list';
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.title = payload.title;
		this.description = payload.description;
		this.key = payload.key;
		this.minItems = payload.minItems;
		this.maxItems = payload.maxItems;
		this.items = items;

		Object.freeze(this);
	}

	get canAdd(): boolean {
		return this.maxItems === null || this.items.length < this.maxItems;
	}

	get canRemove(): boolean {
		return this.minItems === null || this.items.length > this.minItems;
	}
}

export default DocumentListEntryView;
